"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.more_vertical = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const more_vertical = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'more-vertical-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', 
            // eslint-disable-next-line max-len
            d: 'M8.00025 17.0002C8.00025 18.1003 8.90025 19.0002 10.0002 19.0002C11.1002 19.0002 12.0002 18.1003 12.0002 17.0002C12.0002 15.9002 11.1002 15.0002 10.0002 15.0002C8.90025 15.0002 8.00025 15.9002 8.00025 17.0002ZM8.00025 2.99976C8.00025 4.09976 8.90025 4.99976 10.0002 4.99976C11.1002 4.99976 12.0002 4.09976 12.0002 2.99976C12.0002 1.89976 11.1002 0.999756 10.0002 0.999756C8.90025 0.999756 8.00025 1.89976 8.00025 2.99976ZM8.00025 10.0002C8.00025 11.1002 8.90025 12.0002 10.0002 12.0002C11.1002 12.0002 12.0002 11.1002 12.0002 10.0002C12.0002 8.90019 11.1002 8.00019 10.0002 8.00019C8.90025 8.00019 8.00025 8.90019 8.00025 10.0002Z', fill: '#4B5563' })));
};
exports.more_vertical = more_vertical;
